import { render } from "./ClubsView.vue?vue&type=template&id=36e26b00&scoped=true"
import script from "./ClubsView.vue?vue&type=script&lang=js"
export * from "./ClubsView.vue?vue&type=script&lang=js"

import "./ClubsView.css?vue&type=style&index=0&id=36e26b00&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e26b00"]])

export default __exports__